import * as React from 'react';
import { Field } from '../api';
import { formatCell } from './seachpage-helpers';

type FolderRow = { [key: string]: any } & { id: number };

interface Props {
  folders: FolderRow[];
  fields: Field[];
  resultColumns: string[];
  onSelect?: (folder: FolderRow) => void;
  loading?: boolean;
  emptyMessage?: string;
}

export function FolderGrid({ folders, fields, resultColumns, onSelect, loading, emptyMessage }: Props) {
  const visibleCols = resultColumns.length ? resultColumns : fields.map(f => f.name);

  return (
    <div className="docgrid-root">
      <div className="docgrid-scroll">
        {loading && <div className="docgrid-empty">Loading...</div>}
        {!loading && folders.length === 0 && (
          <div className="docgrid-empty">{emptyMessage ?? 'Geen folders gevonden.'}</div>
        )}
        {folders.length > 0 && (
          <table className="docgrid-table">
            <thead>
              <tr>
                {visibleCols.map(col => {
                  const fld = fields.find(f => f.name === col);
                  const title = fld?.title || col;
                  return <th key={col} className="docgrid-thead-th">{title}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {folders.map(f => (
                <tr key={String((f as any).id ?? (f as any).Id)} onClick={() => onSelect?.(f)} className="docgrid-row">
                  {visibleCols.map(col => {
                    const fld = fields.find(ff => ff.name === col);
                    const raw = (f as any).folderValues?.[col] ?? (f as any).FolderValues?.[col] ?? (f as any)[col];
                    const formatted = fld ? formatCell(fld, raw) : raw;
                    return <td key={col} className="docgrid-td">{formatted as any}</td>;
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
